<script>
  import Formulary from './components/formulary.svelte'
  import Headline from './components/headline.svelte'
</script>

<main class="mt-[122px]">
  <section>
    <Headline />
    <Formulary />
  </section>
</main>
